var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-alert',{staticClass:"ma-0",attrs:{"type":"error","value":true,"dense":"","tile":"","single-line":"","text":"","transition":"slide-y-transition"}},[_vm._v(" Route ["+_vm._s(_vm.invalidRouteText)+"] not found. Please check your link. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }